import { useParams } from "react-router-dom"
import { DeckDetail } from "@/components/decks/DeckDetail"
import { useDeckDetail } from "@/hooks/useDeckDetail"

export function DeckDetailRoute() {
  const { id } = useParams()
  const { deck, loading } = useDeckDetail(id)

  if (loading) {
    return <DeckDetail deck={null} loading={true} />
  }

  return <DeckDetail deck={deck} loading={false} />
} 